module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"locked":"Låst"},"en":{"locked":"Locked"}}')
  delete Component.options._Ctor
}
